import {Navigate, useLocation, matchPath} from 'react-router-dom'

import {useProfile} from 'hooks'
import routes from 'routes/pathConfig'
import {isProfileConfirmed} from 'utils'

const OnlyNotAuthRoute = ({children, ...rest}) => {
  const {profile} = useProfile()
  const location = useLocation()
  const {from} = location.state || {from: {pathname: routes.home.path}}
  const isConfimWithToken = matchPath(routes.register.confirmEmail.withToken.to, from?.pathname ?? '')

  if (profile) {
    if (isConfimWithToken) return <Navigate to={from} />
    if (!isProfileConfirmed(profile)) return <Navigate to={routes.register.path} />
    return <Navigate to={from} />
  }
  return children
}

OnlyNotAuthRoute.propTypes = {
  // path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
}

export default OnlyNotAuthRoute
